/* Vendor imports */
import React from 'react'
/* App imports */
import style from './footer.module.less'

const Footer = () => (
  <div className={style.container}>
    <p>Made with Gatbsy.js, using luigi-colella starter template, hosted on GitHub Pages</p>
  </div>
)

export default Footer
